import {Typography, useTransition} from '@yandex-delivery/blocks'
import {logEvent} from '@yandex-delivery/modules/rum/event'
import {config} from 'src/shared/config'
import i18n from 'src/shared/i18n'
import {Brand} from 'src/shared/types'
import {isIos, isSellAndBuy, isUsp} from 'src/shared/utils'

import {useIsMobile} from '../../hooks'
import {YandexPromo, YangoPromo} from '../promo'
import {ServiceCloseButton} from '../service-close-button'
import {isCountry} from './ActiveScreen.utils'
import {classes} from './styles'

const CompleteScreen: React.FC = () => {
  const AppPromo = config.brand === Brand.Yango ? YangoPromo : YandexPromo
  const isUspService = isUsp()

  const getText = () => {
    if (isUspService) {
      return i18n.print('route_usp_order_complete', 'Яндекс Помощник: заказ завершён')
    }

    return config.brand === Brand.Yango ? i18n.print('yango_route_order_complete') : i18n.print('route_order_complete')
  }

  const text = getText()
  const isNotTurkey = !isCountry('tr')

  const isMobile = useIsMobile()
  const isSellAndBuyAvailable = isSellAndBuy()
  const isMobileSellAndBuy = isMobile && isSellAndBuyAvailable
  const isIosDevice = isIos()

  useTransition(() => Promise.resolve(logEvent('route_order_complete')))

  return (
    <div className={classes.root} data-screen="CompleteScreen-Regular">
      {/* Кнопка отображается в вебвью для проекта Sell&Buy, см. https://nda.ya.ru/t/H8o4k4li79xnSK */}
      {isMobileSellAndBuy && <ServiceCloseButton />}

      <div className={`${classes.item} ${classes.illustration}`}>
        <div className={classes.illustrationImage} />
        <Typography className={classes.illustrationText} thickness="bold" variant="title4">
          {text}
        </Typography>
      </div>
      {isNotTurkey && !isSellAndBuyAvailable && !isUspService && !isIosDevice ? (
        <div className={classes.item}>
          <AppPromo fullWidth />
        </div>
      ) : null}
    </div>
  )
}

export default CompleteScreen
